import { render, staticRenderFns } from "./allinpay_set_company.vue?vue&type=template&id=aa8954c2&scoped=true"
import script from "./allinpay_set_company.vue?vue&type=script&lang=js"
export * from "./allinpay_set_company.vue?vue&type=script&lang=js"
import style0 from "./allinpay_set_company.vue?vue&type=style&index=0&id=aa8954c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8954c2",
  null
  
)

export default component.exports